<mat-accordion>
  @for(license of frm.controls; track license){
  <mat-expansion-panel [expanded]="(step$ | async) === $index" (opened)="setStep($index)">
    <mat-expansion-panel-header>
      <mat-panel-title> Licencia {{ license.controls['licenseNumber'].value }} </mat-panel-title>
      <mat-panel-description>
        @if(frm.controls.length > 1){
          <button mat-icon-button (click)="deleteLicense($index, $event)" matTooltip="Eliminar licencia">
            <mat-icon svgIcon="trash-can"></mat-icon>
          </button>
        }
        <button mat-icon-button (click)="addLicense($event)" matTooltip="Añadir nueva licencia">
          <mat-icon svgIcon="plus"></mat-icon>
        </button>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <t-llevo-license-form [frm]="license" [loaderSrv]="loaderSrv" [focusOnFirstInput]="focusOnFirstInput"></t-llevo-license-form>

    <mat-action-row>
      <div class="actions">
        <button mat-button (click)="prevStep()" [disabled]="$first">Anterior</button> 
        <button mat-button (click)="nextStep()" [disabled]="$last">Siguente</button>      
      </div>
    </mat-action-row>
  </mat-expansion-panel>
  }
</mat-accordion>
